import { render } from "./item4.vue?vue&type=template&id=0f152dba&scoped=true"
const script = {}

import "./item4.vue?vue&type=style&index=0&id=0f152dba&lang=scss&scoped=true"

import exportComponent from "/Users/baikaifa/Desktop/ubang-deploy-work/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.42_vue@3.5.42_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f152dba"]])

export default __exports__